var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AddressForm"},[_c('h3',[_vm._v(_vm._s(_vm.$t('form.address.block_name')))]),(_vm.loaded)?_c('div',[_c('AddressGeocode',{attrs:{"address":_vm.address,"showErrors":_vm.showErrors},on:{"address-geocode":_vm.handleAddressGeocode}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }